<template>
  <v-row>
    <v-col cols="12" lg="8" order="12" order-lg="1">
      <v-card>
        <v-card-text>
          <v-container>
            <div>
              <ReceiptsPayment
                  v-if="cartStore.cart2Data != null"
                  :show-cart2-details="loadCart2Details"
                  :cart2-data-details="cartStore.cart2DataDetails"
                  :procedures="cartStore.cart2Data.tramitesCarrito"
                  :set-cart-final-data="setCartFinalData"
                  :default-fiscal-contact="cartStore.cart2Data.defaultDatoSolicitante"
              />
            </div>
          </v-container>
        </v-card-text>
      </v-card>
    </v-col>

    <v-col cols="12" lg="4" order="1" order-lg="12">
      <Checkout
          v-if="cartStore.cart2Data"
          :checkout-data="cartStore.cart2Data.tramitesCheckout"
          :checkout-total="cartStore.cart2Data.checkoutTotal"
          :checkout-items-number="countCheckout2Items"
          :submit-cart="submitCart2"
          :show-all-items="showCheckoutAllItems"
      />
    </v-col>

    <ErrorModal
        :close-error-modal="closeErrorModal"
        :show-modal="showErrorModal"
        :message-code="errorCode"
    />
  </v-row>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import {cart2Request, cartBaseRequest} from '@/api/models';
import Checkout from '../Checkout';
import ReceiptsPayment from './ReceipsPayment';
import ErrorModal from '@/components/Portfolio/Cart2/ErrorModal';
import * as Storage from '@/core/storage.js';
import Constants from '@/core/constants';

export default {
  name: 'Cart2',
  props: ['nextStep'],

  data() {
    return {
      showErrorModal: false,
      errorCode: 0,
      cartFinalData: {},
    };
  },

  components: {Checkout, ReceiptsPayment, ErrorModal},

  computed: {
    ...mapState({cartStore: state => state.cart}),
    ...mapGetters('cart', ['countCheckout2Items']),
  },

  mounted() {
    this.initCart2Data();
  },

  methods: {
    ...mapActions('cart', ['getCartStep2', 'getCheckoutAllItems', 'getCart2Details']),
    ...mapActions('alerts', ['error']),

    // --- FIX: parse seguro para evitar "[object Object]"
    safeParse(item) {
      try {
        if (typeof item === 'string') return JSON.parse(item);
        return item; // si ya es objeto
      } catch (e) {
        return null;
      }
    },

    initCart2Data() {
      let rawCart2 = Storage.getItem('cart2');
      let rawCart3 = Storage.getItem('cart3');
      let contactId = Storage.getItem(Constants.KEY_LAST_FISCAL_CONTACT);

      let cart2 = this.safeParse(rawCart2);
      let cart3 = this.safeParse(rawCart3);

      if (!cart2) {
        this.error('Hubo un error al continuar con el proceso en el paso 2, vuelve a iniciar.');
        this.$router.push({name: 'portfolio', params: {step: 1}});
        return;
      }

      let request = cart2Request();
      request.cart2 = cart2;
      request.cart3 = cart3;
      request.last_dato_solicitante_id = contactId;

      this.getCartStep2(request);
    },

    loadCart2Details() {
      let request = cart2Request();
      request.cart2 = this.safeParse(Storage.getItem('cart2'));
      request.cart3 = this.safeParse(Storage.getItem('cart3'));

      this.getCart2Details(request);
    },

    showCheckoutAllItems() {
      let request = cartBaseRequest();
      this.getCheckoutAllItems(request);
    },

    setCartFinalData(cartFinalData) {
      this.cartFinalData = cartFinalData;
    },

    submitCart2() {
      if (this.validateFinalData()) {
        this.nextStep(2, this.cartFinalData);
      } else {
        this.showErrorModal = true;
      }
    },

    validateFinalData() {
      if (this.cartFinalData.facturar_todo) {
        this.errorCode = 2;
        return this.cartFinalData.d_fiscal != null;
      }

      this.errorCode = 3;
      return (
          Object.keys(this.cartFinalData.d_fiscal).length ===
          this.cartFinalData.tramites.length
      );
    },

    closeErrorModal() {
      this.showErrorModal = false;
    },
  },
};
</script>

<style scoped></style>